module.exports = __webpack_public_path__ + "static/image_54-f61983e5c6a29487a678050ed8d14b96.png";